export class ZeroEtlJobsFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "jobTypes",
            "baseName": "jobTypes",
            "type": "Array<ZeroEtlJobType>",
            "format": ""
        },
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceNames",
            "baseName": "resourceNames",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<ResourceType>",
            "format": ""
        },
        {
            "name": "cloudProviders",
            "baseName": "cloudProviders",
            "type": "Array<Provider>",
            "format": ""
        },
        {
            "name": "sourceAccountName",
            "baseName": "sourceAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountIds",
            "baseName": "sourceAccountIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "sourceRegions",
            "baseName": "sourceRegions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "policyIds",
            "baseName": "policyIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "backupJobId",
            "baseName": "backupJobId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "statuses",
            "baseName": "statuses",
            "type": "Array<JobStatus>",
            "format": ""
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "vaultIds",
            "baseName": "vaultIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "targetNamespace",
            "baseName": "targetNamespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetTable",
            "baseName": "targetTable",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAfter",
            "baseName": "createdAfter",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "createdBefore",
            "baseName": "createdBefore",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "startedAfter",
            "baseName": "startedAfter",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "startedBefore",
            "baseName": "startedBefore",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endedAfter",
            "baseName": "endedAfter",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endedBefore",
            "baseName": "endedBefore",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlJobsFilters.attributeTypeMap;
    }
    constructor() {
    }
}
